export const PUBLISHER_ACL_OBJECTS = [
    'PublisherNew',
    'PublisherDetail',
    'PublisherList',
];
